// extracted by mini-css-extract-plugin
export var activityContainer = "_m4-0";
export var typingIndicatorContainer = "_m4-1";
export var typingIndicatorDot = "_m4-2";
export var wave = "_m4-3";